import { appStyles } from '../App.styles';
// Chat styles
export const chatStyles = {
    container: {
        background: '#FFFFFF',
        borderRadius: '1rem',
        padding: {
            sm: '1.5rem',
            xs: '0.5rem',
        },
        height: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        width: '100%',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
        //maxWidth: '920px',
    },
    aiMessageContainer: {
        background: 'linear-gradient(0deg, rgba(0, 107, 84, 0.05), rgba(0, 107, 84, 0.05)), #F8FAF7',
        borderRadius: '1rem',
        padding: '1rem',
        boxShadow: 'none',
        border: 'none',
    },
    userMessageContainer: {
        borderRadius: '1rem',
        padding: '1rem',
        boxShadow: 'none',
        border: 'none',
    },
    cell: {
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0.25px',
        color: '#000000',
    },
    textBtn: Object.assign(Object.assign({}, appStyles.text14), { borderRadius: '0.5rem', fontWeight: '500', color: 'green.main', boxShadow: 'none', textTransform: 'none', padding: '0.375rem 1rem 0.375rem 0.75rem' }),
    tooltip: Object.assign(Object.assign({}, appStyles.text12), { color: 'whiteDark.main', backgroundColor: 'blackLighter.main', padding: '0.25rem 0.5rem', maxWidth: '12.5rem', boxSizing: 'border-box' }),
};
